import i18n from "@/i18n";

// import * as constans from "@/constants";

const t = i18n.global.t;

const toolData = [
    {
        functionBlock: {
            subTitle: t("viemao_downloader_feature_h2"),
            titleDescribe: t("viemao_downloader_feature_para2"),
            content: [
                {
                    icon: "dollar-none",
                    title: t("viemao_downloader_feature1_h3"),
                    des: t("viemao_downloader_feature1_para1"),
                },
                {
                    icon: "user-x-01",
                    title: t("viemao_downloader_feature2_h3"),
                    des: t("viemao_downloader_feature2_para1"),
                },
                {
                    icon: "advertise",
                    title: t("viemao_downloader_feature3_h3"),
                    des: t("viemao_downloader_feature3_para1"),
                },
                {
                    icon: "zap-fast",
                    title: t("viemao_downloader_feature4_h3"),
                    des: t("viemao_downloader_feature4_para1"),
                },
                {
                    icon: "file-download",
                    title: t("viemao_downloader_feature5_h3"),
                    des: t("viemao_downloader_feature5_para1"),
                },
                {
                    icon: "file-music",
                    title: t("viemao_downloader_feature6_h3"),
                    des: t("viemao_downloader_feature6_para1"),
                },
            ],
        },
        useMethodBlock: {
            subTitle: t("viemao_downloader_steps_h2"),
            content: [
                {
                    imageSuffix: "image-paste-youtube-url.webp",
                    title: t("viemao_downloader_step1_h3"),
                    des: t("viemao_downloader_step1_para1"),
                },
                {
                    imageSuffix: "image-select-file.webp",
                    title: t("viemao_downloader_step2_h3"),
                    des: t("viemao_downloader_step2_para1"),
                },
                {
                    imageSuffix: "image-free-download-video.webp",
                    title: t("viemao_downloader_step3_h3"),
                    des: t("viemao_downloader_step3_para1"),
                },
            ],
        },
        domainBlock: {
            subTitle: t("viemao_downloader_short_h2"),
            content: [
                {
                    title: t("viemao_downloader_short_step1_h3"),
                    des: t("viemao_downloader_short_step1_para1"),
                },
                {
                    title: t("viemao_downloader_short_step2_h3"),
                    des: t("viemao_downloader_short_step2_para1"),
                },
                {
                    title: t("viemao_downloader_short_step3_h3"),
                    des: t("viemao_downloader_short_step3_para1"),
                },
            ],
        },
        questionBlock: {
            subTitle: t("viemao_downloader_support_h2"),
            titleDescribe: t("viemao_downloader_support_para2"),
            content: [
                {
                    title: t("viemao_downloader_support_q1_h3"),
                    contentArr: [
                        {
                            type: "text",
                            value: [t("viemao_downloader_support_q1_para1")],
                        },
                    ],
                },
                {
                    title: t("viemao_downloader_support_q2_h3"),
                    contentArr: [
                        {
                            type: "text",
                            value: [t("viemao_downloader_support_q2_para1")],
                        },
                    ],
                },
                {
                    title: t("viemao_downloader_support_q3_h3"),
                    contentArr: [
                        {
                            type: "text",
                            value: [t("viemao_downloader_support_q3_para1")],
                        },
                    ],
                },
                {
                    title: t("viemao_downloader_support_q4_h3"),
                    contentArr: [
                        {
                            type: "text",
                            value: [t("viemao_downloader_support_q4_para1")],
                        },
                    ],
                },
                {
                    title: t("viemao_downloader_support_q5_h3"),
                    contentArr: [
                        {
                            type: "text",
                            value: [t("viemao_downloader_support_q5_para1")],
                        },
                    ],
                },
            ],
        },
    },
];

export default toolData;
